import { Controller } from "react-hook-form";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";

const ControlledDatePicker = ({
	control,
	name,
	label,
	error,
	errorMessage,
	minDate,
	maxDate,
	shrinkLabel = true,
	fullWidth = false,
}) => {
	return (
		<Controller
			control={control}
			name={name}
			render={({ field: { onChange, value } }) => (
				<DatePicker
					disablePast
					name={name}
					minDate={moment(minDate)}
					maxDate={maxDate ? moment(maxDate) : undefined}
					label={label}
					format="DD/MM/YYYY"
					onChange={onChange}
					value={value ? moment(value) : null}
					slotProps={{
						textField: {
							required: true,
							size: "small",
							error: error,
							helperText: errorMessage ? errorMessage : "",
							fullWidth: fullWidth,
							sx: {
								marginTop: "16px",
								marginBottom: "8px",
								"& .MuiIconButton-root": {
									padding: "0 4px 0 0",
								},
							},
							InputLabelProps: { shrink: shrinkLabel },
						},
					}}
				/>
			)}
		></Controller>
	);
};

export default ControlledDatePicker;
